export default __webpack_public_path__ + "static/lee-e4deaae9eb804a4493f6cac4c74b8d15.jpg";